"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterVariants = void 0;
;
var FilterVariants = /** @class */ (function () {
    function FilterVariants(data) {
        this.values = data;
    }
    return FilterVariants;
}());
exports.FilterVariants = FilterVariants;
//# sourceMappingURL=FilterVariants.js.map